import React from 'react';
import { Translate } from 'react-redux-i18n';
import PropTypes from 'prop-types';
import { CountryFlag as CoreCountryFlag } from 'front-onceforall-core';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const CountryFlag = props => {
  const label = /*#__PURE__*/_jsx(Translate, {
    value: 'country.' + props.country
  });
  return /*#__PURE__*/_jsxs("div", {
    className: "flex-container",
    style: {
      width: '100%'
    },
    children: [/*#__PURE__*/_jsx(CoreCountryFlag, {
      country: props.country,
      size: props.size
    }), !props.hideLabel && /*#__PURE__*/_jsx("span", {
      className: "ellipsis",
      style: {
        width: 'calc(100% - 22px)'
      },
      children: label
    })]
  });
};
CountryFlag.defaultProps = {
  hideLabel: false,
  size: 16
};
CountryFlag.propTypes = {
  country: PropTypes.string.isRequired,
  hideLabel: PropTypes.bool,
  size: PropTypes.number
};
export default CountryFlag;